import { Plane, Search } from "lucide-react";
import { TripTransport, Location } from "@/types/trip";

interface FlightCardProps {
  previousLocation: Location | null;
  nextLocation: Location | null;
  selectedLocation: Location | null;
  flight: TripTransport | null;
  handleTransportButtonClick: (location: Location) => void;
  arrival: boolean;
}

const FlightCard: React.FC<FlightCardProps> = ({
  previousLocation,
  nextLocation,
  selectedLocation,
  flight,
  handleTransportButtonClick,
  arrival,
}) => {
  if (!flight) {
    return NullFlightCard({
      handleTransportButtonClick,
      previousLocation,
      nextLocation,
      selectedLocation,
      arrival,
    });
  } else {
    return null;
  }
};

interface NullFlightCardProps {
  handleTransportButtonClick: (location: Location) => void;
  previousLocation: Location | null;
  nextLocation: Location | null;
  selectedLocation: Location | null;
  arrival: boolean;
}

const NullFlightCard: React.FC<NullFlightCardProps> = ({
  handleTransportButtonClick,
  previousLocation,
  nextLocation,
  selectedLocation,
  arrival,
}) => {
  return (
    <div className="bg-neutral-100/70 rounded-lg py-3 px-4 w-full">
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-row items-center space-x-4">
          <Plane className="w-5 h-5 text-neutral-600" />
          <div className="flex flex-col items-start">
            <p className="text-sm text-neutral-700 font-medium mb-0.5">
              No flight selected -{" "}
              {arrival ? previousLocation?.name : selectedLocation?.name} to{" "}
              {arrival ? selectedLocation?.name : nextLocation?.name}
            </p>
            <p className="text-xs text-neutral-500 font-light">
              Choose a flight to see details here
            </p>
          </div>
        </div>
        <button
          onClick={() =>
            arrival
              ? handleTransportButtonClick(selectedLocation!)
              : handleTransportButtonClick(nextLocation!)
          }
          className="space-x-2 flex items-center bg-indigo-800 rounded-md py-2 px-3"
        >
          <Search className="w-3 h-3 text-white" />
          <h2 className="text-xs font-medium text-white">Search</h2>
        </button>
      </div>
    </div>
  );
};

export default FlightCard;
